// @mui material components
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { MDTypographyProps } from "./MDTypography";

interface MDTypographyRootProps {
  theme?: any,
  ownerState: MDTypographyProps & { darkMode?: boolean },
}

export default styled(Typography)(({ theme, ownerState }: MDTypographyRootProps) => {
  const { palette, typography, functions } = theme;
  const { color, textTransform, verticalAlign, fontWeight, opacity, textGradient, darkMode } =
    ownerState;

  const { gradients, transparent, white } = palette;
  const { fontWeightLight, fontWeightRegular, fontWeightMedium, fontWeightBold } = typography;
  const { linearGradient } = functions;

  // fontWeight styles
  const fontWeights = {
    light: fontWeightLight,
    regular: fontWeightRegular,
    medium: fontWeightMedium,
    bold: fontWeightBold,
  };

  // styles for the typography with textGradient={true}
  const gradientStyles = () => ({
    backgroundImage:
      color !== "inherit" && color !== "text" && color !== "white" && color && gradients[color]
        ? linearGradient(gradients[color].main, gradients[color].state)
        : linearGradient(gradients.dark.main, gradients.dark.state),
    display: "inline-block",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: transparent.main,
    position: "relative",
    zIndex: 1,
  });

  // color value
  let colorValue = color === "inherit" || !color || !palette[color] ? "inherit" : palette[color].main;

  if (darkMode && (color === "inherit" || !color || !palette[color])) {
    colorValue = "inherit";
  } else if (darkMode && color === "dark") colorValue = white.main;

  const fontWeightStyle = fontWeights[fontWeight as 'light' | 'regular' | 'medium' | 'bold'];

  return {
    opacity,
    textTransform,
    verticalAlign,
    textDecoration: "none",
    color: colorValue,
    fontWeight: fontWeight ? fontWeightStyle : null,
    ...(textGradient && gradientStyles()),
  };
});
